<template>
	<div :style="{ height: heightscreen + 'px' }">
		<div style="display: flex; flex-direction: column" v-if="idx === undefined">
			<!-- SIDEBAR -->
			<div class="menu" :style="{ width: sidebar ? '' : '75px' }">
				<button-collapse-sidebar :open="sidebar" @change="sidebar = !sidebar" />
				<folders-sidebar :open="sidebar" />
			</div>

			<div class="main" :style="{ width: widthscreen, marginLeft: !sidebar ? '75px' : '150px' }">
				<div style="padding: 10px; margin-top: 15px">
					<app-breadcrumb :history="breadcrumb" @mutate="doMutate" />
					<div class="header">
						<div class="header_title-container title">
							<h1>{{ this.folder }}</h1>
							<h5>{{ computedDocNumber }}</h5>
						</div>

						<div class="header_actions">
							<div class="header_actions-container">
								<option-button
									:show="true"
									:buttons="buttons"
									:csvEntity="'documents'"
									:csvHeader="csvHeader"
									:csvFilters="getFilters"
									:processCsv="processCsv"
									:csvUrl="computedUrl"
								/>
								<el-button
									icon="el-icon-plus"
									@click="goto('/flowchart/' + folderID)"
									type="success"
									plain
								>
									{{ $t("new-document") }}
								</el-button>
								<search
									:loadDocs="true"
									:loadFolders="false"
									:folderID="$route.params.folder_id"
									from="documents-layout"
									@docSelected="
										item => {
											handleSearch(item.value)
										}
									"
									@folderSelected="item => {}"
									@keyup="
										str => {
											handleSearch(str)
										}
									"
								/>
							</div>
						</div>
					</div>

					<div class="documents infinite-list-wrapper" style="overflow: auto">
						<div
							class="documents_container list"
							v-infinite-scroll="scrollLoad"
							:infinite-scroll-disabled="scrollDisabled"
							infinite-scroll-distance="50"
							style="margin-bottom: 100px"
						>
							<div
								v-for="d in docs"
								:key="d.id + d.actual"
								@mouseover="mousein(d.id)"
								@mouseleave="mouseout(d.id)"
								class="documents_wrapper list-item"
							>
								<div class="documents_upper">
									<div class="documents_thumb">
										<!-- <div :ref="'rnd_' + d.id">
											<Renderer
												v-if="d.preview != undefined"
												:key="uuid()"
												:valore="d.preview[0].items[0]"
												:dati="d.preview"
											></Renderer>
											<div :key="d.id + d.actual" v-else>{{ $t("preview-not-available") }}</div>
										</div> -->
										<div :ref="'rnd_' + d.id" style="display: flex; height: 100%">
											<md-icon class="md-size-5x" style="color: #1a73e8">description</md-icon>
										</div>

										<div :ref="'opt_' + d.id" style="display: none">
											<div>
												<el-button
													type="primary"
													icon="el-icon-view"
													style="width: 100%; margin-top: 5px"
													plain
													@click="viewInfo(d.id, d.unique_id)"
													>{{ $t("see-more") }}
												</el-button>
											</div>
											<div>
												<el-button
													type="primary"
													icon="el-icon-edit"
													style="width: 100%; margin-top: 5px"
													plain
													@click="editInfo(d.id)"
													>{{ $t("edit") }}
												</el-button>
											</div>
											<div>
												<el-button
													type="primary"
													icon="el-icon-copy-document"
													style="width: 100%; margin-top: 5px"
													plain
													@click="cloneDocPopup(d.id)"
													>{{ $t("clone-doc") }}
												</el-button>
											</div>
											<div>
												<el-button
													icon="el-icon-connection"
													style="width: 100%; margin-top: 5px"
													plain
													type="warning"
													@click="connectDocumentPopup(d.id)"
													>{{ $t("folders") }}
												</el-button>
											</div>
											<div>
												<el-button
													type="danger"
													icon="el-icon-delete"
													style="width: 100%; margin-top: 5px"
													plain
													@click="deleteDocPopup(d.id)"
												>
													{{ inFolder ? $t("disconnect") : $t("delete") }}
												</el-button>
											</div>
											<div>
												<el-button
													type="success"
													icon="el-icon-tickets"
													style="width: 100%; margin-top: 5px"
													plain
													@click="showVersions(d.id)"
													>{{ $t("versions") }}
												</el-button>
											</div>
										</div>
									</div>
								</div>
								<div class="documents_details">
									<div class="documents_details-menu">
										<span
											class="md-body-2"
											style="height: min-content; margin-top: auto; margin-bottom: auto"
										>
											{{ $t("version") }}
										</span>
										<el-select
											v-model="d.actual"
											:placeholder="$t('version')"
											@change="changeDocVersion(d.id)"
										>
											<el-option
												v-for="(item, indx) in d.versions"
												:key="item.Id + indx"
												:label="
													item.Version +
													' ' +
													(item.Status == 'published' ? '(' + $t('active') + ')' : '')
												"
												:value="item.Version"
											>
											</el-option>
										</el-select>
									</div>
									<div class="documents_details-infos">
										<div class="documents_details-title">{{ d.title }}</div>
										<div class="documents_details-time">{{ d.time }}</div>
										<div>
											<el-tag style="margin-left: 3px; margin-bottom: 3px" type="warning">
												{{ $t(d.status) }}
											</el-tag>
											<el-tag
												v-for="area in d.areas"
												:key="area.id"
												style="margin-left: 3px; margin-bottom: 3px"
												type="success"
											>
												{{ area.area.name }}
											</el-tag>
											<el-tag
												v-for="tag in d.tags"
												:key="tag.id"
												style="margin-left: 3px; margin-bottom: 3px"
											>
												{{ tag.tag.name }}
											</el-tag>
										</div>
									</div>
								</div>
							</div>
						</div>
						<delete-confirm-modal
							:show="deletePopup"
							:title="!inFolder ? $t('delete-document') : $t('disconnect-document')"
							:content="
								!inFolder ? $t('are-you-sure-delete-document') : $t('are-you-sure-disconnect-document')
							"
							@close="
								todelete => {
									deleteDoc(deleteId, todelete)
								}
							"
						/>
					</div>

					<div class="float-center">
						<div class="float-content-spinner" v-if="scrollLoading">
							<i class="el-icon-loading" />
						</div>
						<div
							class="float-content"
							v-bind:class="{ visible: scrollNoMoreSnackbar, hidden: !scrollNoMoreSnackbar }"
						>
							<div class="float-text">{{ $t("no-more-docs") }}</div>
						</div>
					</div>

					<!-- render modal -->
					<el-dialog
						:key="showModalRender + uuid()"
						:title="$t('preview')"
						:visible.sync="showModalRender"
						width="80%"
						:custom-class="'custom-dialog'"
					>
						<span slot="title"
							><i class="el-icon-document" style="margin-right: 10px; justify-content: center"></i
							>{{ $t("preview") }}</span
						>
						<anteprima
							v-if="showModalRender"
							:key="showModalRender + uuid()"
							:toggleBorders="toggleBorders"
							:doc_id="selected_to_prev"
							:unique="selected_to_prev_unique"
						></anteprima>
						<!--						<flat-renderer-->
						<!--							v-if="showModalRender"-->
						<!--							:dati="selected_nodes"-->
						<!--							id="rend"-->
						<!--							:key="showModalRender + uuid()"-->
						<!--							:toggleBorders="toggleBorders"-->
						<!--						/>-->
						<span slot="footer">
							<el-switch
								v-model="toggleBorders"
								:active-text="$t('with-borders')"
								:inactive-text="$t('without-borders')"
							/>
							<el-button style="margin-left: 20px" type="primary" @click="showModalRender = false">{{
								$t("close")
							}}</el-button>
						</span>
					</el-dialog>

					<versions-modal
						:show="showModalStatus"
						@close="showModalStatus = false"
						:statusesPerVersions="statusesPerVersions"
						@refresh="
							value => {
								refresh(this.$route.params.folder_id)
							}
						"
					/>
					<connect-modal
						:show="connectPopup"
						@close="connectPopup = false"
						:connectId="connectId"
						@refresh="
							value => {
								refresh(this.$route.params.folder_id)
							}
						"
					/>
				</div>
			</div>
		</div>
		<flowchart-layout
			v-else
			@changeVersion="
				element => {
					this.idx = element
				}
			"
			:idroute="idx"
			:key="idx"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import axios from "axios"
import moment from "moment"
import Renderer from "@/modules/builder/components/Renderer"
import FlowchartLayout from "@/modules/flowcharts/flowchart-layout"
import FlatRenderer from "@/modules/flowcharts/flat-renderer"
import VersionsModal from "@/modules/documents/components/versions-modal"
import ConnectModal from "@/modules/documents/components/connect-modal"
import { goto } from "@/utils/utils"
import { uuid } from "@/modules/builder/utils/utils"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"
import FoldersSidebar from "@/modules/documents/components/sidebar-components/folders-sidebar.vue"
import AppBreadcrumb from "@/modules/_common/app-breadcrumb.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"
import Anteprima from "@/modules/documents/anteprima"
import Search from "@/modules/documents/components/search.vue"
import OptionButton from "@/modules/_common/button/option-button.vue"

export default {
	name: "documents-layout",
	components: {
		Anteprima,
		Renderer,
		FlatRenderer,
		FlowchartLayout,
		VersionsModal,
		ConnectModal,
		AppBreadcrumb,
		DeleteConfirmModal,
		Search,
		OptionButton,
		"button-collapse-sidebar": ButtonCollapseSidebar,
		"folders-sidebar": FoldersSidebar
	},
	data() {
		return {
			folder: "",
			docSearch: "",
			docNumber: "",
			docs: [],
			showModal: false,
			selected_to_prev: undefined,
			selected_to_prev_unique: undefined,
			showModalRender: false,
			showModalStatus: false,
			statusesPerVersions: [],
			selected_nodes: [],

			idx: undefined,
			deletePopup: false,
			deleteId: null,
			connectPopup: false,
			connectId: null,
			toggleBorders: false,
			inFolder: false,

			sidebar: true || window.innerWidth < 900,
			widthscreen: window.innerWidth - 150,
			heightscreen: window.innerHeight - 100,
			mobile: window.innerWidth < 900,

			scrollLoading: false,
			scrollNoMoreSnackbar: false,
			scrollEnded: false,
			tilesNumber: 1,
			rowsToLoad: 4,
			loadedPages: 0,

			buttons: ["option", "option-csv"],
			//CSV
			csvHeader: [
				this.$t("id"),
				this.$t("name"),
				this.$t("status"),
				this.$t("versions"),
				this.$t("tags"),
				this.$t("areas"),
				this.$t("updated-at"),
				this.$t("procedure")
			]
		}
	},
	watch: {
		idx() {
			this.docSearch = ""
			this.loadedPages = 0
			this.scrollEnded = false
			this.docs = []
			if (this.$route.params.folder_id) {
				this.getDocs(this.$route.params.folder_id)
			} else {
				this.getDocs()
			}
		},
		"$route.params.folder_id"() {
			this.docSearch = ""
			this.loadedPages = 0
			this.scrollEnded = false
			this.docs = []
			this.load()
		},
		"$route.params.document_id"() {
			this.idx = this.$route.params.document_id
		},
		scrollNoMoreSnackbar() {
			if (this.scrollNoMoreSnackbar) {
				setTimeout(() => {
					this.scrollNoMoreSnackbar = false
				}, 3000)
			}
		}
	},
	computed: {
		...mapGetters({
			breadcrumb: "documents/breadcrumb"
		}),
		computedDocNumber: function () {
			return this.$t("documents-counter").replace("%DOCSNUMBER%", this.docNumber)
		},
		folderID() {
			if (
				this.$route.params.folder_id == "all" ||
				this.$route.params.folder_id == undefined ||
				this.$route.params.folder_id == 0
			)
				return ""
			else return this.$route.params.folder_id
		},
		scrollDisabled() {
			return this.scrollLoading || this.scrollEnded
		},
		computedUrl() {
			var url = process.env.VUE_APP_API_URL + "/api/flowchart"
			if (this.$route.params.folder_id == undefined) {
				url = process.env.VUE_APP_API_URL + "/api/flowchart/all"
			}

			return url
		}
	},
	created() {
		if (this.$route.params.document_id) {
			this.idx = this.$route.params.document_id
		}
		this.tilesNumber = Math.floor((this.widthscreen - 90) / 340)
		this.load()
	},
	methods: {
		...mapMutations({
			openLoad: "modules/OPEN_LOADING",
			closeLoad: "modules/CLOSE_LOADING"
		}),
		...mapActions({
			doMutate: "documents/doMutate"
		}),

		async querySearch(queryString, cb) {
			var results = await this.prefetchTest(queryString)

			// call callback function to return suggestions
			cb(results)
		},
		handleSelect(item) {
			this.docSearch = item.value
			// this.handleSearch()
		},

		prefetchTest(string) {
			return axios
				.get(process.env.VUE_APP_API_URL + "/api/flowchart/prefetch/" + string, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					return res.data.items
				})
				.catch(err => {
					this.folder = this.$t("no-folder-generic")
					console.error(err)
				})
		},

		scrollLoad() {
			this.loadedPages++
			this.getDocs(this.$route.params.folder_id)
		},
		handleSearch(str = "") {
			this.docSearch = str
			this.loadedPages = 0
			this.scrollEnded = false
			this.scrollLoading = false
			this.scrollNoMoreSnackbar = false
			this.docs = []
			this.getDocs(this.$route.params.folder_id)
		},
		refresh(id) {
			this.loadedPages = 0
			this.scrollEnded = false
			this.scrollLoading = false
			this.scrollNoMoreSnackbar = false
			this.docs = []
			this.getDocs(id)
		},
		load() {
			this.inFolder = false
			if (this.$route.params.folder_id == "all" || this.$route.params.folder_id == undefined)
				this.folder = this.$t("all-docs")
			else if (this.$route.params.folder_id == 0) this.folder = this.$t("no-folder-generic")
			else {
				this.inFolder = true
				axios(`${process.env.VUE_APP_API_URL}/api/folders/${this.$route.params.folder_id}`, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
					.then(({ data: { name } }) => (this.folder = name))
					.catch(err => {
						this.folder = this.$t("no-folder-generic")
						console.error(err)
					})
			}

			this.getDocs(this.$route.params.folder_id)
		},
		changeDocVersion(doc_id) {
			const element_index = this.docs.findIndex(el => el.id == doc_id)
			axios
				.get(
					process.env.VUE_APP_API_URL +
						"/api/flowchart/get/" +
						doc_id +
						"/" +
						this.docs[element_index].actual,
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					this.docs[element_index] = {
						id: res.data.items.Id,
						title: res.data.items.Title,
						status: res.data.items.Status,
						areas: res.data.items.Areas,
						tags: res.data.items.Tags,
						time: res.data.items.Preview
							? this.$t("last-edit") +
							  " " +
							  moment(res.data.items.Preview.created_at.substring(0, 19)).format("LLL")
							: this.$t("last-edit") + " " + moment(moment.now()).format("LLL"), // xx minutes ago
						versions: res.data.items.Versions,
						actual: res.data.items.Versions.find(el => el.Id == res.data.items.Id).Version,
						preview: res.data.items.Preview
							? [{ items: [JSON.parse(res.data.items.Preview.json)] }]
							: undefined // primo elemento del flowchart come anteprima
					}
					this.$forceUpdate()
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
				})
		},

		getDocs(id) {
			var payload = {
				pagination: {
					offset: this.loadedPages * this.tilesNumber * this.rowsToLoad,
					size: this.rowsToLoad * this.tilesNumber
				},
				search: this.docSearch.toLowerCase(),
				id: id //might be undefined
			}

			if (!this.scrollEnded) {
				this.scrollLoading = true
				axios
					.post(this.computedUrl, payload, {
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					})
					.then(res => {
						this.docNumber = res.data.total
						for (let i = 0; i < res.data.items.length; i++) {
							this.docs.push({
								id: res.data.items[i].Id,
								title: res.data.items[i].Title,
								status: res.data.items[i].Status,
								areas: res.data.items[i].Areas,
								unique_id: res.data.items[i].UniqueID,
								tags: res.data.items[i].Tags,
								time:
									this.$t("last-edit") +
									" " +
									moment(
										res.data.items[i].Versions[
											res.data.items[i].Versions.length - 1
										].updated_at.substring(0, 19)
									).format("LLL"), // xx minutes ago
								// time: (res.data.items[i].Preview) ? moment(res.data.items[i].Preview.created_at.substring(0, 19) + '+02:00').fromNow() : moment(res.data.items[i].Versions[res.data.items[i].Versions.length-1].updated_at).fromNow(), // xx minutes ago
								versions: res.data.items[i].Versions,
								actual: res.data.items[i].Versions.find(el => el.Id == res.data.items[i].Id).Version,
								preview: res.data.items[i].Preview
									? [{ items: [JSON.parse(res.data.items[i].Preview.json)] }]
									: undefined // primo elemento del flowchart come anteprima
							})
						}
						this.scrollLoading = false
					})
					.catch(err => {
						this.scrollLoading = false
						this.scrollNoMoreSnackbar = true
						this.scrollEnded = true
					})
			} else {
				this.scrollNoMoreSnackbar = true
			}
		},
		mousein(i) {
			const elHide = this.$refs[`rnd_${i}`][0]
			const elShow = this.$refs[`opt_${i}`][0]
			elHide.style.display = "none"
			elShow.style.cssText =
				"display:flex; flex-direction: column; justify-content: space-around; height: 100%; padding: 15px !important;"
		},
		mouseout(i) {
			const elHide = this.$refs[`opt_${i}`][0]
			const elShow = this.$refs[`rnd_${i}`][0]
			elHide.style.display = "none"
			elShow.style.cssText = "display: flex; height: 100%"
		},
		viewInfo(id, unique) {
			this.selected_to_prev = id
			this.selected_to_prev_unique = unique
			this.showModalRender = true
			// axios
			// 	.get(process.env.VUE_APP_API_URL + "/api/flowchart/getSaved/" + id, {
			// 		headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			// 	})
			// 	.then(res => {
			// 		this.selected_nodes = []
			// 		res.data.items.dati.forEach((el, index) => {
			// 			if (el.value) {
			// 				var tttmp = { id: 0, items: [], name: "" }
			// 				el.value.forEach(el78 => {
			// 					tttmp.items.push(JSON.parse(el78.items))
			// 				})
			// 				el.value = [tttmp]
			// 			}
			// 			el.id = index
			// 			this.selected_nodes.push(el)
			// 		})
			// 		this.showModalRender = true
			// 	})
			// 	.catch(err => {
			// 		this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
			// 	})
		},
		goto,
		uuid,
		editInfo(idx) {
			this.goto("/documents/all-docs/" + idx)
		},
		showVersions(id) {
			const element_index = this.docs.findIndex(el => el.id == id)
			this.showModalStatus = true
			this.statusesPerVersions = this.docs[element_index].versions
		},
		deleteDocPopup(idx) {
			this.deletePopup = true
			this.deleteId = idx
		},
		cloneDocPopup(id) {
			this.$confirm(this.$t("sure-clone-doc"), this.$t("clone-doc"), {
				confirmButtonText: this.$t("confirm"),
				cancelButtonText: this.$t("cancel")
			}).then(({ value }) => {
				axios
					.get(process.env.VUE_APP_API_URL + "/api/flowchart/clone/" + id, {
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					})
					.then(res => {
						this.refresh(this.$route.params.folder_id)
						this.$notification("success", this.$t("save-successful"), this.$t("clone-doc-successful"))
					})
					.catch(err => {
						this.$processError(this.$t("save-error"), err.response.data.Message)
					})
			})
		},
		connectDocumentPopup(idx) {
			this.connectPopup = true
			this.connectId = idx
		},
		deleteDoc(idx, todelete) {
			this.deletePopup = false
			if (!todelete) return

			if (this.$route.params.folder_id && this.$route.params.folder_id != 0) {
				//scollegamento
				axios
					.post(
						process.env.VUE_APP_API_URL + "/api/folders/disconnectDocument",
						{
							doc: idx,
							folder: this.$route.params.folder_id
						},
						{ headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } }
					)
					.then(res => {
						const idxDoc = this.docs.findIndex(x => x.id === idx)
						this.docs.splice(idxDoc, 1)
						this.docNumber--
						this.$notification("success", this.$t("doc-disconnected"), "")
					})
					.catch(err => {
						this.$processError(this.$t("delete-error"), err.response.data.Message)
					})
			} else {
				//eliminazione
				axios
					.post(
						process.env.VUE_APP_API_URL + "/api/flowchart/deleteDoc",
						{ id: idx },
						{
							headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
						}
					)
					.then(res => {
						const indxDocs = this.docs.findIndex(x => x.id === idx)
						this.docs.splice(indxDocs, 1)
						this.docNumber--
						this.$notification("success", this.$t("deleted-successfully"), "")
					})
					.catch(err => {
						this.$processError(this.$t("delete-error"), err.response.data.Message)
					})
			}
		},
		getFilters(withFilters, page = undefined, size = undefined) {
			if (!withFilters)
				return {
					pagination: {},
					search: undefined,
					id: this.$route.params.folder_id
				}

			if (size && page) {
				this.pagination.size = size
				this.pagination.offset = (page - 1) * this.pagination.size
			}

			var filters = {
				search: this.docSearch.toLowerCase(),
				pagination: {
					deleted_at: this.deleted_at
				},
				id: this.$route.params.folder_id
			}

			if (size && page) {
				filters.pagination.offset = this.pagination.offset
				filters.pagination.size = this.pagination.size
			}

			return filters
		},
		processCsv: function (item) {
			let data = []

			let tags = item.Tags.map(t => t.tag.name)
			let areas = item.Areas.map(a => a.area.name)
			let folders = item.Folders ? item.Folders.map(f => f.name) : []

			data.push("id: " + item.Id)
			data.push('"' + item.Title.replace(/"/g, '""') + '"')
			data.push('"' + this.$t(item.Status) + '"')

			let versions = []
			item.Versions.forEach(v => {
				versions.push(`${v.Version} - ${this.$t(v.Status)}`)
			})

			data.push('"' + versions.join("\n") + '"')
			data.push('"' + tags.join("\n") + '"')
			data.push('"' + areas.join("\n") + '"')

			data.push(item.UpdatedAt ? moment(item.UpdatedAt).format("DD/MM/YYYY HH:mm:ss") : "-")

			data.push('"' + folders.join("\n") + '"')

			return data
		}
	}
}
</script>
<style>
.custom-dialog {
	margin-top: 10vh !important;
}
</style>
<style scoped lang="scss">
@import "src/assets/scss/collapse-button";
@import "@/assets/scss/documents.scss";

.main {
	margin-top: -25px;
}

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.item {
	padding: 17px 10px;
	cursor: pointer;
	color: #cfd8dc;
	width: 100%;

	& :hover {
		border-left: 3px solid #6ff9ff;
	}

	display: flex;

	.md-icon {
		margin-left: 5px;
		margin-right: 5px;
	}

	span {
		margin-top: auto;
		margin-bottom: auto;
	}
}

.item-selected {
	border-left: 3px solid #6ff9ff;
	color: white;
	background-color: rgba(127, 127, 127, 0.1);
}

.selected {
	color: #6ff9ff;
}

.float-content-spinner {
	width: 50px;
	height: 50px;
	font-size: 40px;
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
	padding-top: 5px;
	transform: translate(-25px);
}

.float-content {
	width: 300px;
	height: 30px;
	transform: translate(-150px);
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
}

.visible {
	visibility: visible;
	opacity: 1;
}

.hidden {
	visibility: hidden;
	opacity: 0;
	transition: visibility 0s 1s, opacity 1s linear;
}

.float-text {
	padding-top: 5px;
}
</style>
